/**
 * Utility functions for event action cooldown management
 * Prevents spam clicking by enforcing a 30-second cooldown between actions
 */

const COOLDOWN_SECONDS = 3;

/**
 * Checks if enough time has passed since the last action
 * @param {string|null} lastActionTime - ISO timestamp of last action (from updated_at)
 * @returns {Object} { canPerform: boolean, secondsRemaining: number }
 */
export function checkCooldown(lastActionTime) {
  if (!lastActionTime) {
    return { canPerform: true, secondsRemaining: 0 };
  }

  const lastAction = new Date(lastActionTime);
  const now = new Date();
  const secondsSinceLastAction = Math.floor((now - lastAction) / 1000);
  const secondsRemaining = COOLDOWN_SECONDS - secondsSinceLastAction;

  return {
    canPerform: secondsRemaining <= 0,
    secondsRemaining: Math.max(0, secondsRemaining)
  };
}

/**
 * Formats remaining cooldown time for display
 * @param {number} secondsRemaining - Seconds remaining in cooldown
 * @returns {string} Formatted time string (e.g., "25 sekund")
 */
export function formatCooldownTime(secondsRemaining) {
  if (secondsRemaining <= 0) return '';
  
  if (secondsRemaining === 1) {
    return '1 sekundę';
  } else if (secondsRemaining < 5) {
    return `${secondsRemaining} sekundy`;
  } else {
    return `${secondsRemaining} sekund`;
  }
}

export { COOLDOWN_SECONDS };
